import { useState, useEffect } from "react";
// @mui
import {
  TextField,
  Card,
  CardContent,
  Typography,
} from "@mui/material";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
//
import { useTranslation } from "react-i18next";

const style = {
  "& > *": { my: "8px !important" },
};

// ----------------------------------------------------------------------

export default function ClientForm(props) {
  const [settings, setSettings] = useState(props.settings);
  const [errors, setErrors] = useState({
    clientOfferNumber: "",
    clientDate: "",
  });
  const { t } = useTranslation();

  const checkCanNext = () => {
    if (
      settings.clientData.offerNumber &&
      settings.clientData.date 
      // && settings.clientData.infos // not required
    ) {
      props.canNext(true);
      return true;
    } else {
      props.canNext(false);
      return false;
    }
  };

  const handleChange = (element, value) => {
    if (element == "clientOfferNumber") {
      setSettings({
        ...settings,
        clientData: { ...settings.clientData, offerNumber: value },
      });
      checkRequiredValue(element, value);
    } else if (element == "clientInfos") {
      setSettings({
        ...settings,
        clientData: { ...settings.clientData, infos: value },
      });
      // checkRequiredValue(element, value); // not required
    } else if (element == "clientNotes") {
      setSettings({
        ...settings,
        clientData: { ...settings.clientData, notes: value },
      });
    } else {
      setSettings({
        ...settings,
        clientData: { ...settings.clientData, references: value },
      });
    }
  };

  const handleDateChange = (value) => {
    setSettings({
      ...settings,
      clientData: { ...settings.clientData, date: value },
    });
    if (!(value instanceof Date)) {
      setErrors({ ...errors, clientDate: t("errors.field_required") });
    } else {
      setErrors({ ...errors, clientDate: "" });
    }
  };

  const checkRequiredValue = (element, value) => {
    if (value === "") {
      setErrors({ ...errors, [element]: t("errors.field_required") });
    } else {
      setErrors({ ...errors, [element]: "" });
    }
  };

  useEffect(() => {
    if (props.canNext) {
      props.canNext(false);
      if (checkCanNext()) {
        props.onSettingsChange(settings);
      }
    } else {
      props.onSettingsChange(settings);
    }
  }, [settings]);

  useEffect(() => {
    if (props.canNext) {
      var errors = { clientOfferNumber: "", clientDate: "" };

      if (!settings.clientData.offerNumber) {
        errors.clientOfferNumber = t("errors.field_required");
      }
      if (!settings.clientData.date) {
        errors.clientDate = t("errors.field_required");
      }
      // if (!settings.clientData.infos) { // not required
      //   errors.clientInfos = t("errors.field_required");
      // }

      setErrors(errors);
    }
  }, []);

  return (
    <Card sx={{ margin: "16px 0" }}>
      <CardContent title="Type" sx={style}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Typography>{t("dialogs.save_configuration.subtitle")}</Typography>
          <TextField
            fullWidth
            id="clientOfferNumber"
            type="text"
            label={t("context.clientData.offer_number")}
            defaultValue={settings.clientData.offerNumber}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => handleChange(e.target.id, e.target.value)}
            helperText={errors.clientOfferNumber && errors.clientOfferNumber}
            FormHelperTextProps={{ error: true }}
          />
          <DesktopDatePicker
            label={t("context.clientData.date")}
            name="clientDate"
            inputFormat="dd/MM/yyyy"
            value={settings.clientData.date}
            onChange={handleDateChange}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                id="client-date"
                helperText={errors.clientDate && errors.clientDate}
                FormHelperTextProps={{ error: true }}
              />
            )}
            disablePast
          />
          <TextField
            fullWidth
            id="clientInfos"
            type="text"
            label={t("context.clientData.client_infos")}
            defaultValue={settings.clientData.infos}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => handleChange(e.target.id, e.target.value)}
            helperText={errors.clientInfos && errors.clientInfos}
            FormHelperTextProps={{ error: true }}
          />
          <TextField
            fullWidth
            id="clientNotes"
            type="text"
            label={t("context.clientData.client_notes")}
            defaultValue={settings.clientData.notes}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => handleChange(e.target.id, e.target.value)}
          />
          <TextField
            fullWidth
            multiline
            id="clientReferences"
            type="text"
            label={t("context.clientData.client_references")}
            defaultValue={settings.clientData.references}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => handleChange(e.target.id, e.target.value)}
          />
        </LocalizationProvider>
      </CardContent>
    </Card>
  );
}
